export default "__VITE_ASSET__56cbd6fd__"